export {
	ConfirmationMessageComponent,
	ConfirmationMessageData,
} from './confirmation-message.component';
export {
	ConfirmationPassComponent,
	ConfirmationPassData,
} from './confirmation-pass.component';
